import React, { useEffect, useState } from "react";
import "../style.css";
import { getEntityList } from "../action";
import { useDispatch, useSelector } from "react-redux";
import Gstr2a2bFilter from "../Utility/Filter";
import { recoBase } from "./constants";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import { InputLabel } from "@material-ui/core";
import ToleranceDropdown from "../Utility/ToleranceDropdown";
import { DropdownDateRangePicker } from "./SelectDateRange";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import FinancialYearDropdown from "../Utility/FinancialYearDropdown";
import CustomSelect from "../Utility/CustomSelect";
import { getEndDate, getStartDate } from "../Utility/utility";
import { format, parseISO } from "date-fns";
import SubHeaderBar from "./SubHeaderBar";
import { getGenerateReport, setRecoSelection, setSelectedYear, setSelection } from "./action";
import { COMMON_MSGS } from "Constant/Messages";
import { errorToastMessage } from "utils/errorToast";
const HeaderBar = (props) => {
  const dispatch = useDispatch();
  // const [recoTypeValue, setRecoTypeValue] = useState([]);
  // const [recoBaseValue, setRecoBaseValue] = useState([]);
  const {
    runReco,
    runFuzzy,
    includeITC,
    setRunReco,
    setRunFuzzy,
    setIncludeITC,
    dateRange,
    // setDateRange,
    taxRate,
    setTaxRate,
    taxableValue,
    setTaxableValue,
    // selectedYear,
    // selection,
    // recoSelection,
    // setSelectedYear,
    // setSelection,
    // setRecoSelection,
    handleGenerateReport,
    handleSubmit
  } = props;
  const { entityMasterList, profileData, defaultEntity, selectedGstin } =
    useSelector((store) => store.gstr2a2bNewCommonReducer);
  const { activeTabReco, loaderStatus,selection,recoSelection,selectedYear } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  useEffect(() => {
    dispatch(getEntityList());
  }, []);
  // const handleRecoTypeFilter = (currentNode, selectedNodes) => {
  //   let selectedValues = selectedNodes.map((node) => node.value);
  //   setRecoTypeValue(selectedValues);
  // };
  // const handleRecoBaseFilter = (currentNode, selectedNodes) => {
  //   let selectedValues = selectedNodes.map((node) => node.value);
  //   setRecoBaseValue(selectedValues);
  // };
  // useEffect(() => {
  //   console.log("recoBaseValue:", recoBaseValue);
  //   console.log("recoTypeValue:", recoTypeValue);
  // }, [recoBaseValue, recoTypeValue]);
  // const [startYear, setStartYear] = useState(new Date());
  // const [selection, setSelection] = useState("");
  // const [recoSelection, setRecoSelection] = useState("");
  // const [selectedYear, setSelectedYear] = useState("");
  // const [taxableValue, setTaxableValue] = useState("");
  // const [taxRate, setTaxRate] = useState("");
  // const [dateRange, setDateRange] = useState([
  //   {
  //     // startDate: getStartDate(selectedYear),
  //     // endDate:  getEndDate(selectedYear),
  //     startDate: new Date(),
  //     endDate: new Date(),
  //     key: "selection",
  //   },
  // ]);
  // const [runReco, setRunReco] = useState(true);
  // const [runFuzzy, setRunFuzzy] = useState(true);
  // const [includeITC, setIncludeITC] = useState(true);

  const handleRunReco = (event) => {
    setRunReco(event.target.checked);
  };
  const handleRunFuzzy = (event) => {
    setRunFuzzy(event.target.checked);
  };
  const handleIncludeITC = (event) => {
    setIncludeITC(event.target.checked);
  };
  const handleChange = (event) => {
    dispatch(setSelection(event.target.value));
  };
  const handleRecoTypeFilter = (event) => {
    dispatch(setRecoSelection(event.target.value));
  };
  const handleSelectedYear = (event) => {
    dispatch(setSelectedYear(event.target.value));
  };
  // useEffect(() => {
  //   // console.log("defaultEntity::", defaultEntity);
  //   // console.log("selectedGstin::", selectedGstin);
  //   // console.log("recoSelection::", recoSelection);
  //   // console.log("selection::", selection);
  //   // console.log("selectedYear::", selectedYear);
  //   // console.log("taxRate::", taxRate);
  //   // console.log("taxableValue::", taxableValue);
  //   // console.log('dateRange start::',dateRange.startDate);
  //   // console.log('dateRange end::',dateRange.endDate);
  // });
  const formatDateRecoTab = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      try {
        return format(parseISO(date), "dd MMM");
      } catch {
        console.error("Invalid ISO date string:", date);
        return "";
      }
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
      return format(date, "dd MMM");
    }
    console.error("Invalid date value:", date);
    return "";
  };
  // const handleGenerateReport = () => {
  //   if (
  //     defaultEntity &&
  //     selectedGstin?.length > 0 &&
  //     selection &&
  //     recoSelection &&
  //     selectedYear &&
  //     (taxRate || taxableValue)
  //   ) {
  //     dispatch(
  //       getGenerateReport(
  //         selectedGstin,
  //         selection,
  //         recoSelection,
  //         selectedYear,
  //         taxRate,
  //         taxableValue,
  //         dateRange,
  //         runReco,
  //         runFuzzy,
  //         includeITC,
  //         activeTabReco
  //       )
  //     );
  //   } else {
  //     errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
  //   }
  // };
  return (
    <>
      <div style={{ display: "flex" }}>
        <div style={{ width: "65%" }}>
          <Gstr2a2bFilter
            entityMasterList={entityMasterList}
            profileData={profileData}
            flag={"reconciliationTab"}
            handleRecoTypeFilter={handleRecoTypeFilter}
            recoSelection={recoSelection}
          />
        </div>
        <div
          style={{ width: "17%", marginLeft: "1.6em", marginTop: "0.4em" }}
          className="gstr2a2bDatePicker"
        >
          <FinancialYearDropdown
            handleChange={handleSelectedYear}
            selectedYear={selectedYear}
          />
          {/* <InputLabel
                id="demo-simple-select-autowidth-label"
                className="text_label"
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "12px",
                  color: "black",
                  top: "10px",
                }}
              >
                Select Financial Year *
              </InputLabel>
              <DatePicker
                selected={startYear}
                onChange={(date) => setStartYear(date)}
                showYearPicker
                dateFormat="yyyy"
                 className="custom-datepicker"
              /> */}
        </div>
        {/* <div
          style={{ width: "18%", marginTop: "6px" }}
          className="dropdown-container-gstr2a2b"
        >
          <InputLabel
            id="demo-simple-select-autowidth-label"
            className="text_label"
            style={{
              fontFamily: "GT-Walsheim-medium",
              fontSize: "12px",
              color: "black",
              top: "10px",
            }}
          >
            Select Reco Type *
          </InputLabel>
          <Container data={recoType} onChange={handleRecoTypeFilter}  mode="simpleSelect"/>
        </div> */}
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{ width: "21%", marginTop: "6px" }}
          className="dropdown-container-gstr2a2b"
        >
          <InputLabel
            id="demo-simple-select-autowidth-label"
            className="text_label"
            style={{
              fontFamily: "GT-Walsheim-medium",
              fontSize: "12px",
              color: "black",
              top: "10px",
            }}
          >
            Select Reco Base *
          </InputLabel>
          {/* <Container
            data={recoBase}
            onChange={handleRecoBaseFilter}
            mode="simpleSelect"
          /> */}
          <CustomSelect
            values={recoBase}
            optionHeading={"Select Reco Base"}
            selectedValue={selection}
            handleChange={handleChange}
            setSelectedValue={setSelection}
          />
        </div>
        <div
          style={{ width: "22%", marginLeft: "1.6em", marginTop: "5px" }}
          className="dropdown-container-gstr2a2b"
        >
          {/* <label
                    style={{
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "12px",
                      // marginBottom: "2px",
                    }}
                  > */}
          <InputLabel
            id="demo-simple-select-autowidth-label"
            className="text_label"
            style={{
              fontFamily: "GT-Walsheim-medium",
              fontSize: "12px",
              color: "black",
              top: "10px",
            }}
          >
            Select Document Date Range
          </InputLabel>
          <DropdownDateRangePicker
            initialStartDate={selectedYear ? getStartDate(selectedYear) : null}
            initialEndDate={selectedYear ? getEndDate(selectedYear) : null}
            minDate={selectedYear ? getStartDate(selectedYear) : null}
            maxDate={selectedYear ? getEndDate(selectedYear) : null}
            // setDateRange={setDateRange}
            dateRange={dateRange}
            width={"210px"}
            formatDateRecoTab={formatDateRecoTab}
            tab="Reco"
            selection={selection}
          />
        </div>
        <div
          style={{ width: "21%", marginTop: "6px", marginLeft: "0.7em" }}
          className="dropdown-container-gstr2a2b"
        >
          <InputLabel
            id="demo-simple-select-autowidth-label"
            className="text_label"
            style={{
              fontFamily: "GT-Walsheim-medium",
              fontSize: "12px",
              color: "black",
              top: "10px",
            }}
          >
            Select Tolerance Limit
          </InputLabel>
          <ToleranceDropdown
            width={"192px"}
            taxRate={taxRate}
            taxableValue={taxableValue}
            setTaxableValue={setTaxableValue}
            setTaxRate={setTaxRate}
          />
        </div>
      </div>
      <div>
        <SubHeaderBar
          runReco={runReco}
          runFuzzy={runFuzzy}
          includeITC={includeITC}
          handleRunReco={handleRunReco}
          handleRunFuzzy={handleRunFuzzy}
          handleIncludeITC={handleIncludeITC}
          handleGenerateReport={handleGenerateReport}
          handleSubmit={handleSubmit}
        />
      </div>
    </>
  );
};

export default HeaderBar;
